import { createSelector } from 'reselect';
import { getBookSelector } from '@Selectors/publication/book/selector/get-book.selector';
import { BookView } from '@Selectors/publication/book/view/book.view';
import { BookSectionView } from '@Selectors/publication/book/view/book-section.view';

export const bookPresenter = createSelector(
  [getBookSelector],
  (book): BookView => {
    return new BookView({
      id: book?.id ?? '0',
      name: book?.name ?? '',
      armyLogo: book?.armyLogo ?? null,
      armyName: book?.armyName ?? '',
      sections:
        book?.sections
          ?.filter((section) => !section.isDeleted)
          ?.map((section) => {
            return new BookSectionView({
              item: section,
              id: section.id,
              index: section.position,
              position: `0${section.position}`.slice(-2),
              name: 'section.name',
            });
          })
          ?.sort((a, b) => a.index - b.index) ?? [],
    });
  },
);
